/* @flow */
import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

import ElectroSelect from '../ElectroSelect/ElectroSelect';

import styles from './ElectroSelectWithOther.module.scss';

/**
 * ElectroSelectWithOther
 * VirtualizedSelect with TextField for 'Other' and helper text for error message
 *
 * @prop {Object} field
 * @prop {String} heading
 * @prop {String} otherHeading
 * @prop {Array<Object>} options
 * @return {FormControl}
 */

type TypeProps = {
  field: Object,
  heading?: string,
  otherHeading?: string,
  options?: Array<Object>,
  selectUp?: boolean,
};

class ElectroSelectWithOther extends React.Component<*> {
  @observable isOther: boolean = false;

  @observable selectedId: string = '';

  get options(): Array<Object> {
    const { field, options }: TypeProps = this.props;

    return (
      options ||
      (field.extra && field.extra.options
        ? field.extra.options
        : field.options
        ? field.options
        : [])
    );
  }

  setValue = (value: string, id: string) => {
    const { field }: TypeProps = this.props;

    this.selectedId = id;
    this.isOther = id === 'other';

    field.key = value === '' ? 'other' : field.name;

    field.set(value);
  };

  render(): FormControl {
    const { field, otherHeading, selectUp }: TypeProps = this.props;

    return (
      <div className={styles['form-group']}>
        <FormControl>
          <FormGroup>
            <ElectroSelect
              field={field}
              options={this.options}
              value={this.selectedId}
              labelKey="label"
              valueKey="id"
              simpleValue={false}
              searchable={false}
              onChange={(option: Object) => {
                const value: ?string = option === null || option.id === 'other' ? '' : option.label;
                const id: string = option ? option.id : '';

                this.setValue(value, id);
              }}
              selectUp={selectUp}
            />
          </FormGroup>
          {this.isOther && (
            <FormGroup>
              <TextField
                multiline={true}
                rows="3"
                autoFocus={true}
                label={otherHeading}
                error={Boolean(field.error && field.showError)}
                value={field.value}
                onChange={(evt: SyntheticInputEvent<*>) => {
                  const value: string = evt.target.value;

                  this.setValue(value, 'other');
                  field.validate();
                }}
              />
            </FormGroup>
          )}
          {field.error && field.showError && this.isOther && (
            <FormHelperText error={true}>{field.error}</FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }
}

export default observer(ElectroSelectWithOther);
